
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[city]/sitemap",
      function () {
        return require("private-next-pages/[city]/sitemap.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[city]/sitemap"])
      });
    }
  